import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ eyebrow, title, moreTo, moreLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        {eyebrow ? (
          <span className="mb-1 block text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">{eyebrow}</span>
        ) : null}
        <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">{title}</h2>
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 text-sm font-medium text-foreground-500 transition-colors hover:text-accent-600 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      ) : null}
    </div>
  );
}